import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";

export default function BarbeirosPage() {
    const barbers = useQuery(api.index.barbers_list) ?? [];
    const salvarBarbeiro = useMutation(api.index.barbers_upsert);
    const [novoNome, setNovoNome] = useState("");
    const [novoAtivo, setNovoAtivo] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [barbeiroSelecionado, setBarbeiroSelecionado] = useState<
        string | null
    >(barbers[0]?._id ?? null);

    useEffect(() => {
        const first = barbers[0];
        if (!barbeiroSelecionado && first?._id)
            setBarbeiroSelecionado(first._id as string);
    }, [barbers, barbeiroSelecionado]);

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                {/* Seção de Barbeiros */}
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                                <svg
                                    className="w-6 h-6 text-blue-600 dark:text-blue-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                    />
                                </svg>
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                    Barbeiros
                                </h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    Gerencie a equipe da barbearia
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="p-6 space-y-4">
                        {/* Lista de barbeiros */}
                        <div className="space-y-3">
                            {barbers.length === 0 ? (
                                <div className="text-center py-8">
                                    <svg
                                        className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500 mb-4"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                        />
                                    </svg>
                                    <h4 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                        Nenhum barbeiro cadastrado
                                    </h4>
                                    <p className="text-gray-500 dark:text-gray-400">
                                        Adicione o primeiro barbeiro da sua
                                        equipe
                                    </p>
                                </div>
                            ) : (
                                barbers.map((b) => (
                                    <div
                                        key={b._id}
                                        className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4"
                                    >
                                        <div className="flex items-center gap-4">
                                            <div className="w-12 h-12 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
                                                <svg
                                                    className="w-6 h-6 text-gray-600 dark:text-gray-300"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                                    />
                                                </svg>
                                            </div>

                                            <div className="flex-1 min-w-0">
                                                <input
                                                    defaultValue={b.name}
                                                    onBlur={(e) => {
                                                        const value =
                                                            e.target.value.trim();
                                                        if (
                                                            !value ||
                                                            value === b.name ||
                                                            value.length < 2
                                                        ) {
                                                            e.target.value =
                                                                b.name;
                                                            return;
                                                        }
                                                        salvarBarbeiro({
                                                            _id: b._id,
                                                            name: value,
                                                            active: b.active,
                                                            userSubject:
                                                                b.userSubject,
                                                        });
                                                    }}
                                                    placeholder="Nome do barbeiro"
                                                    className="w-full text-lg font-medium bg-transparent border-none outline-none text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-emerald-500 rounded px-2 py-1"
                                                />
                                                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                                    {b.active
                                                        ? "Barbeiro ativo"
                                                        : "Barbeiro inativo"}
                                                </p>
                                            </div>

                                            <div className="flex items-center">
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        defaultChecked={
                                                            b.active
                                                        }
                                                        onChange={(e) =>
                                                            salvarBarbeiro({
                                                                _id: b._id,
                                                                name:
                                                                    b.name ||
                                                                    "Barbeiro",
                                                                active: e.target
                                                                    .checked,
                                                                userSubject:
                                                                    b.userSubject,
                                                            })
                                                        }
                                                        className="sr-only peer"
                                                    />
                                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 dark:peer-focus:ring-emerald-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-emerald-600"></div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        {/* Formulário para adicionar novo barbeiro */}
                        <div className="border-t border-gray-200 dark:border-gray-600 pt-4">
                            <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-3">
                                Adicionar novo barbeiro
                            </h4>
                            <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    if (!novoNome.trim()) return;

                                    setIsSubmitting(true);
                                    try {
                                        await salvarBarbeiro({
                                            name: novoNome.trim(),
                                            active: novoAtivo,
                                        });
                                        setNovoNome("");
                                        setNovoAtivo(true);
                                    } finally {
                                        setIsSubmitting(false);
                                    }
                                }}
                                className="space-y-3"
                            >
                                <div className="flex gap-3">
                                    <input
                                        value={novoNome}
                                        onChange={(e) =>
                                            setNovoNome(e.target.value)
                                        }
                                        placeholder="Nome do barbeiro"
                                        className="flex-1 px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                                        required
                                    />
                                    <button
                                        type="submit"
                                        disabled={
                                            !novoNome.trim() || isSubmitting
                                        }
                                        className="px-6 py-3 bg-emerald-500 text-white rounded-lg font-medium hover:bg-emerald-600 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
                                    >
                                        {isSubmitting ? (
                                            <svg
                                                className="w-4 h-4 animate-spin"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                                />
                                            </svg>
                                        )}
                                        Adicionar
                                    </button>
                                </div>

                                <label className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={novoAtivo}
                                        onChange={(e) =>
                                            setNovoAtivo(e.target.checked)
                                        }
                                        className="w-4 h-4 text-emerald-600 bg-gray-100 border-gray-300 rounded focus:ring-emerald-500 focus:ring-2"
                                    />
                                    <span className="text-sm text-gray-700 dark:text-gray-300">
                                        Barbeiro ativo
                                    </span>
                                </label>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Seção de Disponibilidade */}
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-emerald-100 dark:bg-emerald-900 rounded-lg">
                                <svg
                                    className="w-6 h-6 text-emerald-600 dark:text-emerald-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                    Horários de Funcionamento
                                </h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    Configure os horários disponíveis para
                                    agendamento
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="p-6">
                        <Disponibilidade
                            barberId={barbeiroSelecionado}
                            onChangeBarber={setBarbeiroSelecionado}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function Disponibilidade({
    barberId,
    onChangeBarber,
}: {
    barberId: string | null;
    onChangeBarber: (id: string) => void;
}) {
    const barbers = useQuery(api.index.barbers_list) ?? [];
    const [weekday, setWeekday] = useState<number>(1);
    const [inicio, setInicio] = useState<string>("09:00");
    const [fim, setFim] = useState<string>("18:00");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const salvar = useMutation(api.index.availability_upsert);
    const blocks =
        useQuery(
            api.index.availability_listForBarber,
            barberId ? { barberId: barberId as any } : "skip",
        ) ?? [];

    if (barbers.length === 0) {
        return (
            <div className="text-center py-8">
                <svg
                    className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
                <h4 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                    Nenhum barbeiro cadastrado
                </h4>
                <p className="text-gray-500 dark:text-gray-400">
                    Adicione um barbeiro primeiro para configurar horários
                </p>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* Seleção de barbeiro */}
            <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Selecione o barbeiro:
                </label>
                <select
                    value={barberId ?? ""}
                    onChange={(e) => onChangeBarber(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                >
                    <option value="">Selecione um barbeiro</option>
                    {barbers.map((b) => (
                        <option key={b._id} value={b._id as string}>
                            {b.name}
                        </option>
                    ))}
                </select>
            </div>

            {barberId && (
                <>
                    {/* Lista de horários configurados */}
                    <div className="space-y-2">
                        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            Horários configurados:
                        </h4>

                        {blocks.length === 0 ? (
                            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 text-center">
                                <svg
                                    className="mx-auto h-8 w-8 text-gray-400 dark:text-gray-500 mb-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <p className="text-gray-500 dark:text-gray-400">
                                    Nenhum horário configurado
                                </p>
                                <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">
                                    Adicione os horários de funcionamento do
                                    barbeiro
                                </p>
                            </div>
                        ) : (
                            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg divide-y divide-gray-200 dark:divide-gray-600">
                                {blocks
                                    .sort(
                                        (a, b) =>
                                            a.weekday - b.weekday ||
                                            a.startMinutes - b.startMinutes,
                                    )
                                    .map((b) => (
                                        <div
                                            key={b._id}
                                            className="px-4 py-3 flex items-center justify-between"
                                        >
                                            <div className="flex items-center gap-3">
                                                <div className="w-8 h-8 bg-emerald-100 dark:bg-emerald-900 rounded-full flex items-center justify-center">
                                                    <span className="text-sm font-medium text-emerald-600 dark:text-emerald-400">
                                                        {weekdayName(
                                                            b.weekday,
                                                        ).charAt(0)}
                                                    </span>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-900 dark:text-white">
                                                        {weekdayName(b.weekday)}
                                                    </div>
                                                    <div className="text-sm text-gray-500 dark:text-gray-400">
                                                        {minutesToTime(
                                                            b.startMinutes,
                                                        )}{" "}
                                                        às{" "}
                                                        {minutesToTime(
                                                            b.endMinutes,
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full">
                                                Ativo
                                            </span>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>

                    {/* Formulário para adicionar novo horário */}
                    <div className="border-t border-gray-200 dark:border-gray-600 pt-6">
                        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
                            Adicionar novo horário:
                        </h4>

                        <form
                            onSubmit={async (e) => {
                                e.preventDefault();
                                setIsSubmitting(true);
                                try {
                                    await salvar({
                                        barberId: barberId as any,
                                        weekday,
                                        startMinutes: timeToMinutes(inicio),
                                        endMinutes: timeToMinutes(fim),
                                    });
                                    setWeekday(1);
                                    setInicio("09:00");
                                    setFim("18:00");
                                } finally {
                                    setIsSubmitting(false);
                                }
                            }}
                            className="space-y-4"
                        >
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Dia da semana
                                    </label>
                                    <select
                                        value={weekday}
                                        onChange={(e) =>
                                            setWeekday(Number(e.target.value))
                                        }
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                                    >
                                        {[1, 2, 3, 4, 5, 6, 0].map((d) => (
                                            <option key={d} value={d}>
                                                {weekdayName(d)}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Horário de início
                                    </label>
                                    <input
                                        value={inicio}
                                        onChange={(e) =>
                                            setInicio(e.target.value)
                                        }
                                        type="time"
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                                    />
                                </div>

                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                        Horário de fim
                                    </label>
                                    <input
                                        value={fim}
                                        onChange={(e) => setFim(e.target.value)}
                                        type="time"
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                                    />
                                </div>
                            </div>

                            <button
                                type="submit"
                                disabled={
                                    isSubmitting ||
                                    timeToMinutes(inicio) >= timeToMinutes(fim)
                                }
                                className="w-full px-6 py-3 bg-emerald-500 text-white rounded-lg font-medium hover:bg-emerald-600 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
                            >
                                {isSubmitting ? (
                                    <>
                                        <svg
                                            className="w-4 h-4 animate-spin"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                            />
                                        </svg>
                                        Adicionando...
                                    </>
                                ) : (
                                    <>
                                        <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                        </svg>
                                        Adicionar horário
                                    </>
                                )}
                            </button>

                            {timeToMinutes(inicio) >= timeToMinutes(fim) && (
                                <p className="text-sm text-red-600 dark:text-red-400">
                                    O horário de início deve ser anterior ao
                                    horário de fim
                                </p>
                            )}
                        </form>
                    </div>
                </>
            )}
        </div>
    );
}

function weekdayName(d: number): string {
    const names = [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
    ] as const;
    return names[d] ?? "";
}
function timeToMinutes(t: string) {
    const parts = t.split(":").map((x) => parseInt(x, 10));
    const hh = parts[0] ?? 0;
    const mm = parts[1] ?? 0;
    return hh * 60 + mm;
}
function minutesToTime(m: number) {
    const hh = String(Math.floor(m / 60)).padStart(2, "0");
    const mm = String(m % 60).padStart(2, "0");
    return `${hh}:${mm}`;
}
